// src/vue/program-list/src/composables/useFormSubmit.ts
import { useRouter } from 'vue-router';
import { useProgramStore } from '@ProgramList/stores/programStore';

export function useFormSubmit() {
	const router = useRouter();
	const programStore = useProgramStore();

    // marked async so you can await router.push()
	async function handleFormSubmit(data: { keyword: string; interests: string[]; types: string[] }) {
		programStore.setFilters(data);

		const keyword = data.keyword;
		const interests = data.interests.join(',');
		const types = data.types.join(',');

		// setup our filter data to send along
		const query = new URLSearchParams({
			keyword,
			interests,
			types,
		}).toString();

		// if our startView is filter, force a full page load on the results page template
		if (programStore.startView === 'filter') {
            const appEl = document.querySelector<HTMLElement>('#app[data-submit-route]')
            
            const cmsRoute = appEl?.getAttribute('data-submit-route');
			const route = `${cmsRoute}#/results?${query}`;
			window.location.replace(route);
		} else {
			await router.push({
				path: '/results',
				query: {
					keyword,
					interests,
					types,
				},
			});
		}
	}

	return { handleFormSubmit };
}
